/**
 * Contrato de errores de la aplicacion.
 *
 * Vive aparte del mock a proposito: estos codigos NO son un detalle de la
 * simulacion, son el contrato que el backend real debera emitir tambien. Que
 * estuvieran dentro de `mockBackend` obligaba a la interfaz a importar del mock
 * para reaccionar a un error, cruzando una frontera que existe justamente para
 * que eso no pase.
 *
 * La interfaz decide que mostrar segun el `code`, nunca segun el texto del
 * mensaje: asi una reescritura de la redaccion en el servidor no rompe nada.
 */

export const ERROR_CODE = {
  NOT_FOUND: 'DEVICE_NOT_FOUND',
  ALREADY_LINKED_BY_YOU: 'ALREADY_LINKED_BY_YOU',
  ALREADY_LINKED_BY_OTHER: 'ALREADY_LINKED_BY_OTHER',
  INVALID_CODE: 'INVALID_CODE',
  LIMIT_REACHED: 'PLAN_LIMIT_REACHED',
  NETWORK: 'NETWORK_ERROR',
  PAYMENT_DECLINED: 'PAYMENT_DECLINED',
};

export class ApiError extends Error {
  constructor(code, message, details = {}) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.details = details;
  }
}
